import "./ccHero.css";

/* Copy left, one square photo right — no form here; booking lives in the
   closing CTA and in this button. The copy steps in on the same header
   entrance the ambassador, about and pricing pages use. */

import { FadeIn } from "../../ui/fade-in";
import heroPhoto from "../../../assets/career-center-home.webp";

const CcHero = () => (
  <section className="cc-hero">
    <div className="home-container cc-hero-grid">
      <div className="cc-hero-copy">
        {/* Names the audience before the headline does, the way the job
            seeker, about, pricing and resources heads all open. .cc-eyebrow
            already carried the blue treatment for the section heads further
            down the page — this is the same one. */}
        <FadeIn delay={0}>
          <span className="cc-eyebrow">RAIN for career centers</span>
        </FadeIn>

        <FadeIn delay={0.1}>
          <h1 className="cc-hero-title">
            Reach every student, not just the ones who book appointments
          </h1>
        </FadeIn>

        <FadeIn delay={0.2}>
          <p className="cc-hero-sub">
            RAIN gives students guided support between appointments, with your
            office at the center of every step. It can also run your job board,
            employer CRM, and appointments, so the whole office works from one
            system.
          </p>
        </FadeIn>

        <FadeIn delay={0.3}>
          <a className="cc-hero-btn" href="#book">
            Book a walkthrough
          </a>
        </FadeIn>
      </div>

      <FadeIn delay={0.2} className="cc-hero-photo">
        {/* The LCP element on this page. Eager and high priority on purpose;
            src/components/CareerCenters/index.jsx preloads the same file. */}
        <img
          width={1180}
          height={664}
          decoding="async"
          loading="eager"
          fetchpriority="high"
          src={heroPhoto}
          alt="Students and advisors working together in a campus career center"
        />
      </FadeIn>
    </div>
  </section>
);

export default CcHero;
